import React from 'react';
import TpEvaluatorService from '../../../Services/TpEvaluatorService';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpEvaluatorSchedulingSearchParams from './TpEvaluatorSchedulingSearchParams';
import TpEvaluatorSchedulingItem from '../../../Domain/TpEvaluatorSchedulingItem';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import CommentsOverWindow from '../../../Elements/CommentsOverWindow';

class TpEvaluatorSchedulingAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new TpEvaluatorSchedulingSearchParams(),
      cleared: process.env.NODE_ENV !== 'development',
      shownPanel: ShownPanelsEnum.None,
      selectedItem: {},
    };
    this.startSearch = this.startSearch.bind(this);
    this.handleExportOnClick = this.handleExportOnClick.bind(this);
    TpEvaluatorSchedulingItem.commentsFunction = this.showCommentsFunction.bind(this);
  }

  showCommentsFunction(item) {
    this.setState({
      selectedItem: item,
      shownPanel: ShownPanelsEnum.Details,
    });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.Details,
          <CommentsOverWindow
            entityTypeId={505}
            entityId={this.state.selectedItem.TpEvaluatorId}
            label={`Comments for Evaluator: ${this.state.selectedItem.FirstName} ${this.state.selectedItem.LastName}`}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
          />
        )}
      </div>
    );
  }

  startSearch(searchItem) {
    this.setState({
      searchItem,
      cleared: false,
    });
  }

  handleExportOnClick() {
    TpEvaluatorService.ExportToExcelForView(this.state.searchItem).catch(() => ErrorMessage.SetErrorMessage('TPEPA31'));
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderPanels()}
        <TabOfDataTable
          type={TpEvaluatorSchedulingItem}
          serviceFunction={TpEvaluatorService.GetAllItemBySearchingForScheduling}
          convertDBItemsFunction={TpEvaluatorService.ConvertDBItemsForScheduling}
          searchParamsType={TpEvaluatorSchedulingSearchParams}
          orderDirection={OrderDirectionsEnum.Asc}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          cleared={this.state.cleared}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different id, name or email...'
          errorCode='TPEPA52'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportOnClick}
        />
      </div>
    );
  }
}

export default TpEvaluatorSchedulingAdmin;
